import script from "./AdminClubSignups.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminClubSignups.vue?vue&type=script&setup=true&lang=js"

import "./AdminClubSignups.vue?vue&type=style&index=0&id=3db918c0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3db918c0"]])

export default __exports__